import routes from "./routes.json";
import { getJsonLd } from "./jsonld";

const SITE = "https://www.thekrstudio.com";
const DEFAULT_OG = `${SITE}/assets/og-image.jpg`;

export const Seo = ({ path, title, description, noindex = false, jsonLd }) => {
  const r = (path && routes.find((x) => x.path === path)) || {};
  const t = title || r.title;
  const d = description || r.description;
  const canonical = r.path ? (r.path === "/" ? `${SITE}/` : `${SITE}${r.path}`) : null;
  const og = r.ogImage || DEFAULT_OG;
  const isDefaultOg = og === DEFAULT_OG;
  const robots = r.robots || (noindex || r.indexable === false ? "noindex,follow" : null);
  const graph = jsonLd || (path ? getJsonLd(path) : null);

  return (
    <>
      <title>{t}</title>
      <meta name="description" content={d} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="KR Studio" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={og} />
      {isDefaultOg && <meta property="og:image:width" content="1200" />}
      {isDefaultOg && <meta property="og:image:height" content="630" />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={og} />
      {robots && <meta name="robots" content={robots} />}
      {graph && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({ "@context": "https://schema.org", "@graph": graph }),
          }}
        />
      )}
    </>
  );
};
